__turbopack_context__.v({
  "advancedCardSourcing": "ForLYW_advancedCardSourcing",
  "advancedCardTable": "ForLYW_advancedCardTable",
  "advancedCardTableFirst": "ForLYW_advancedCardTableFirst",
  "advancedCardTableHeader": "ForLYW_advancedCardTableHeader",
  "advancedCardTitle": "ForLYW_advancedCardTitle",
  "advancedForm": "ForLYW_advancedForm",
  "advancedNoResult": "ForLYW_advancedNoResult",
  "advancedNotice": "ForLYW_advancedNotice",
  "advancedResultCard": "ForLYW_advancedResultCard",
  "advancedResultScore": "ForLYW_advancedResultScore",
  "advancedResults": "ForLYW_advancedResults",
  "apiCodeSample": "ForLYW_apiCodeSample",
  "featureName": "ForLYW_featureName",
  "researchBar": "ForLYW_researchBar",
  "researchContent": "ForLYW_researchContent",
  "scoreExplanation": "ForLYW_scoreExplanation",
  "subregionCell": "ForLYW_subregionCell",
  "territoryCell": "ForLYW_territoryCell",
});
